enum SeekerListGroupType {
  NONE = 'NONE',
  POSITION = 'POSITION',
  BUSINESS_LOCATION = 'BUSINESS_LOCATION',
}

export default SeekerListGroupType;
